/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const categoryService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllCategories: builder.query({
          query: () => "/category-management/managed-category",
        }),
  
        getAllCatWithSubCat: builder.query({
          query: () => "/filter-management/category-subcategory",
          providesTags: ['cat']
        }),
  
        getCatWithSubCatById: builder.query({
          query: (id) => `/filter-management/category-subcategory/${id}`,
          providesTags: ['cat']
        }),
  
        getCategoryById: builder.query({
          query: (catId) => `/category-management/managed-category/${catId}`,
          providesTags: ['cat']
        }),
  
        getAllTopCategories: builder.query({
          query: () => `/category-management/managed-topcategory`,
          providesTags: ['cat']
        }),
  
        createCategory: builder.mutation({
          query: (categoryDetails) => ({
            url: '/category-management/managed-productCategory',
            method: 'POST',
            body: categoryDetails
          }),
          invalidatesTags: ['cat']
        }),
  
        updateCategory: builder.mutation({
          query: (categoryDetails) => ({
            url: '/category-management/managed-category',  
            method: 'PUT',
            body: categoryDetails
          }),
          invalidatesTags: ['cat']
        }),
  
        deleteCategory: builder.mutation({
          query: (catId) => ({
              url: `/category-management/managed-category/${catId}`,
              method: 'POST',
          }),
          invalidatesTags: ['cat']
        }),
  
      })
});

export const {
    useGetAllCategoriesQuery,
    useGetAllCatWithSubCatQuery,
    useLazyGetAllCatWithSubCatQuery,
    useLazyGetCatWithSubCatByIdQuery,
    useGetCategoryByIdQuery,
    useLazyGetCategoryByIdQuery,
    useGetAllTopCategoriesQuery,
    useCreateCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
} = categoryService;

// export endpoints for use in SSR
export const { 
    getAllCategories
} = categoryService.endpoints;
